<template>
 <div id="app" class="modal">
    <div class="modal-window">
        <div class="review">
            <div class="review-message">
                <h3>{{t('Vurder din erfaring med')}} {{data.name}}</h3>
            </div>
            <div class="review-overall">
                {{t('Samlet bedømmelse')}}:
                <star-rating :inline="true"
                             :star-size="20"
                             :show-rating="false"
                             v-model="review.overall">
                </star-rating>
            </div>

            <div class="review-content">
                <textarea cols="50" rows="10" v-model="review.content" :placeholder="t('Indtast din anmeldelse beskrivelse')">
                </textarea>
            </div>

        </div>

        <div class="actions">
             <button :disabled="awaitingSubmition" class="confirm" @click="onConfirm">{{t('Bekræfte')}}</button>
             <button class="cancel" @click="onCancel">{{t('Annuller')}}</button>
        </div>
    </div>
 </div>
</template>

<script>
import VueStarRating from 'vue-star-rating'
import axios from 'axios'
export default {
    name: 'ReviewConsultant',

    props: {
        data: {
            type: Object,
            default: null
        }
    },

    data () {
        return {
            review: {
                overall: 5,
                content: ''
            },
            awaitingSubmition: false,
            user_id: -1,
            serverUrl: '',
            errorMsg: null
        }
    },

    mounted() {
        if (typeof window.serverUrl !== 'undefined') {
            this.serverUrl = window.serverUrl;
        }
    },

    methods: {
        onConfirm() {
            // If a previous submission is taking place
            if (this.awaitingSubmition) {
                return;
            }
            this.awaitingSubmition = true;
            this.googleAnalyticsEvent({
              eventCategory: 'konsulent',
              eventAction: 'konsulent-ring-review-bekraeft',
              eventLabel: this.data.name,
              eventValue: this.review.overall
            });

            let postData = {
                "consultant": this.data.ClairvoyantId,
                "customer": this.data.CustomerId,
                "overall": this.review.overall,
                "content": this.review.content
            };
            axios({
                  method : 'post',
                  url    : serverUrl+'consultant/rating',
                  data   : postData,
                })
                .then((response) => {
                    if (response.data['status'] == 'success') {
                        this.review.username = response.data.username;
                        this.review.overall = response.data.overall;

                        this.$emit("confirm", this.review);
                    }
                    else {
                        this.errorMsg = response.data.error;
                    }
                    this.awaitingSubmition = false;
                })
                .catch((error) => {
                console.log(error);
                })

        },
        onCancel() {
            this.$emit("cancel");
        }
    },
    components: {
        'star-rating': VueStarRating,
    }
}
</script>

<style scoped>
.modal {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 2;
    width: 100%;
}

.modal-window {
    position: absolute;
    top: 50%;
    left: 50%;
    transition: .5s;
    width: 40%;
    min-width: 400px;
    max-width: 600px;
    background: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, .5);
    transform: translate(-50%, -50%);
    padding: 1em;
    color: black;
    text-align: center;
}
.actions button {
    font-size: inherit;
    margin: 4px;
    border: none;
    padding: 6px 8px;
    cursor: pointer;
}

.actions .cancel {
    background: darkred;
    color: white;
}

.actions .confirm {
    background: darkcyan;
    color: white;
}
button {
    cursor: pointer;
}

.review-content {
    margin: 20px;
}

.review-content textarea{
    width: 100%;
}

.review-overall {
    margin: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReviewConsultant.vue